module.exports = __webpack_public_path__ + "static/media/11.eef017f7.jpg";